module.exports = __webpack_public_path__ + "img/394.5d972353.gif";